<template>
    <div class="platform-info-edit-wrp ft-12">
        <!-- <div class="warning-tips">
            <i class="el-icon-info warning-tips-icon"/>
            <span>应拼多多平台的要求，商品在铺货时必须要带上外部商品链接信息，否则就会受到处罚。因此在铺货拼多多前建议您先把该商品铺货到其它平台，或提前在基础资料中维护宝贝链接（其他平台的该宝贝链接），如未铺货到其它平台或设置宝贝链接信息，可能会造成铺货异常！</span>
        </div> -->
        <el-form class="form" :model="value" :rules="rules" ref="form" label-width="12%">
            <slot name="errMsg"></slot>
            <section>
                <div class="title ft-12">
                    <span>基础信息</span>
                </div>
                <div class="conf">
                    <el-form-item label="商品分类:" prop="categoryIds">
                       <div class="category ft-12">
                            <category-input v-model="value.categoryIds" :isSupportAi="true" :platform="platform" :baseItemId="baseItemId" ref="categoryInput" @change="handleCategoryChanged" />
                       </div>
                    </el-form-item>
                    <el-form-item label="商品标题" prop="goodsName">
                        <el-input
                            type="text"
                            placeholder="请输入"
                            v-model="value.goodsName"
                            >
                            <span slot="suffix" style="margin-right: 6px;">{{titleLength}}/60</span>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="商品描述" prop="goodsDesc">
                        <el-input
                            type="text"
                            placeholder="请输入商品描述"
                            v-model="value.goodsDesc"
                            >
                        </el-input>
                        <!-- <p class="tips ft-12">铺货时商品描述为空，默认填充商品名称作为商品描述</p> -->
                    </el-form-item>
                    <el-form-item v-if="categoryId && brandShopList.length" label="品牌" prop="shopBrandConf">
                        <BrandIdBlock
                            ref="brandIdBlock"
                            :categoryIds="value.categoryIds"
                            :baseItemId="baseItemId"
                            v-model="value.shopBrandConf"
                            :shopList="brandShopList"
                            filterable
                            remote
                        />
                    </el-form-item>
                    <el-form-item label="类目属性" v-if="categoryId">
                        <UseCategoryTemplate :detailHasCategory="detailHasCategory" :detailId="value.id" :baseItemId="baseItemId" :categoryIds="value.categoryIds" :platform="platform" :propValues="value.itemPropValues" @clickFill="clickTemPlateFill">
                            <CategoryAttr 
                                v-model="value.itemPropValues" 
                                :initAttrData="initAttrData" 
                                :baseItemId="baseItemId"
                                :categoryIds="value.categoryIds"
                                :pddConfig="pddConfig"
                                :goodsSn="value.goodsSn"
                                @updateSpec="updateSpec"
                                @updateDiscount="updateDiscount"
                                @updateGoodsServiceRule="updateGoodsServiceRule"
                                ref="categoryAttr"
                                :shopList="shopList"
                            />
                        </UseCategoryTemplate>
                    </el-form-item>
                    <el-form-item label="引用套图:" v-if="showGroupImages">
                        <div class="ft-12">商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link> </div>
                        <GroupImagesList :baseItemId="baseItemId" :specifications="propSpecifications" :hideImgs="['mainImages34']" @useOk="useGroupImages" @getList="getGroupImagesList"></GroupImagesList>
                    </el-form-item>
                    <el-form-item label="商品轮播图:" prop="carouselGallery">
                        <div class="imgs-wrp">
                            <div class="ft-12">展示时只取主图，拖动可调整顺序<BatchEditImages v-model="value.carouselGallery" refName="carouselGallery" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
                            <MutiImgUpload 
                                v-model="value.carouselGallery" 
                                ref="carouselGallery"
                                limitSuffix=".jpg,.jpeg,.png" 
                                :key="JSON.stringify(autoCropImageConfigList)"
                                :limitNums="50"
                                :limitHeight="isCheckCarouselGalleryImg ? [480, 0]:[0,0]"
                                :limitWidth="isCheckCarouselGalleryImg ? [480, 0] : [0,0]"
                                :limitSize="isCheckCarouselGalleryImg ? 3 * 1024 * 1024 : 0"
                                :size="200"
                                :aspectRatio="isCheckCarouselGalleryImg ? [1,0.75]:0"
                                :aspectRatioText="isCheckCarouselGalleryImg ? '1:1或3:4' : ''"
                                :supportAiRetry="true"
                                :autoCropImageParams="{publishAutoCropImageEnum:'PDD_CarouselImg'}"
                            />
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <p class="tips ft-12">
                            图片格式支持JPEG/JPG/PNG， 图片尺寸长宽比1：1或3:4，且尺寸不低于480px，图片大小最高3MB；<br />
                            支持批量传图，最多上传50张图片
                        </p>
                    </el-form-item>
                    <el-form-item label="商品详情图:" prop="detailGallery">
                        <div><BatchEditImages v-model="value.detailGallery" refName="detailGallery" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
                        <div class="imgs-wrp">
                            <MutiImgUpload 
                                v-model="value.detailGallery"
                                ref="detailGallery"
                                :key="JSON.stringify(autoCropImageConfigList)"
                                :mainImgNums="0" 
                                :limitNums="50"
                                limitSuffix=".jpg,.png,.jpeg" 
                                :limitHeight="isCheckDesc ? [0, 1500] : [0,0]"
                                :limitWidth="isCheckDesc ? [480, 1200] : [0,0]"
                                :limitSize="isCheckDesc ? 3 * 1024 * 1024 : 0"
                                :size="200"
                                :needAutoCrop="true"
                                :supportAiRetry="true"
                                :autoCropImageParams="{publishAutoCropImageEnum:'PDD_Desc'}"
                            />
                        </div>
                        <p class="tips ft-12">
                            尺寸要求宽度处于480~1200px之间，高度0-1500px之间, 大小3M以内<br />
                            超过3万像素的详情图可能导致无法铺货，需要修改详情图或者找拼多多客服申请超高详情图的发布权限<br />
                            最多上传50张, 图片格式仅支持JPG,JPEG,PNG格式
                        </p>
                    </el-form-item>
                    <el-form-item label="商品活动素材图:" prop="imageUrl">
                        <div class="imgs-wrp">
                            <div class="img-ctx">
                                <div>
                                    <div>商品白底图: </div>
                                    <ImgUpload
                                        :width="80"
                                        :height="80"
                                        :file="value.imageUrl1.content"
                                        @upload-success="(url) => uploadImgSuccess(url, 1)"
                                        @del="() => {deleteImg(1)}"
                                        :isSingle="true"
                                    />
                                </div>
                                <div>
                                    <div>商品长图: </div>
                                    <ImgUpload
                                        :width="80"
                                        :height="80"
                                        :file="value.imageUrl3.content"
                                        @upload-success="(url) => uploadImgSuccess(url, 3)"
                                        @del="() => {deleteImg(3)}"
                                        :isSingle="true"
                                    />
                                </div>
                            </div>
                            <div class="tips ft-12">
                                <span>*商品发布成功且审核通过后，系统会自动上传素材图片,请耐心等待</span>
                                <span>若商品审核被拒，素材会上传失败</span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item v-if="goodsServiceRuleMap['needUploadPackageLabel']" label="包装标签图:" prop="packageLabelGallery" :rules="[{ required: !!goodsServiceRuleMap['needUploadPackageLabelRequired'], message: '请上传包装标签图' }]">
                        <div class="imgs-wrp">
                            <MutiImgUpload
                                v-model="value.packageLabelGallery"
                                ref="packageLabelGallery"
                                :key="JSON.stringify(autoCropImageConfigList)"
                                limitSuffix=".jpg,.jpeg,.png"
                                :limitNums="10"
                                :limitHeight="[480, 0]"
                                :limitWidth="[480, 0]"
                                :limitSize="3 * 1024 * 1024"
                                :size="200"
                                :aspectRatio="[1, 0.75]"
                                :aspectRatioText="'1:1 或 3:4'"
                                :mainImgNums="0"
                                :isCheckImg="true"
                                :needAutoCrop="true"
                                :autoCropImageParams="{publishAutoCropImageEnum:'PDD_PackageLabelImg'}"
                                @change="packageLabelGalleryChange"
                            />
                            <div v-if="packageLabelGalleryError" class="upload-error-tips">{{ packageLabelGalleryError }}</div>
                        </div>
                        <p class="tips ft-12">
                            图片要求：宽高比例为1:1或3:4，且宽高均大于480px，大小3M内，已上传 <span style="color:#F56C6C">{{ value.packageLabelGallery.filter(url => !!url).length }}</span>/10 张
                        </p>
                    </el-form-item>
                    <el-form-item label="商品轮播视频:">
                        <div class="imgs-wrp">
                            <div class="ft-12" style="color: #ccc;">
                                铺货时，视频须事先上传店铺，仅支持店铺上传成功的商品轮播视频，若店铺未上传商品轮播视频，则不会发布视频信息。审核状态可点击 视频审核详情 查看。</br>
                                下载拼多多商品后，若需将视频信息自动上传至其他拼多多店铺，可前往拼多多铺货配置，设置店铺信息。<el-link href="/distributor/prod_conf?tabName=distribution&platform=pdd&platformName=拼多多" target="_blank">前往配置</el-link> 
                            </div>
                            <el-button @click="shopsUpdateVideo" type="text">店铺上传视频</el-button>
                            <el-button @click="videoStateDialog.visible = true" type="text">
                                视频审核详情
                                <video-state :visible.sync="videoStateDialog.visible" :value="[baseItemId]" :openSource="openSource" :carouselVideoId="value.carouselVideoId" :formData="formData" />
                            </el-button>
                            <!-- 视频组件 -->
                            <el-row type="flex" align="middle">
                                <VideoUpload @upload-success="v => handleVideo(v, 1)" :video="value.carouselVideoVo" aspectRatio="1:1,3:4,16:9" :limitWidth="[600, 0]" :limitHeight="[600, 0]" @del="v => handleVideo(v, 0)" :limitDuration="300" :limitTitle="64" :companyId="userInfo.companyId"/>
                            </el-row>
                            <p class="tips ft-12">
                                <span>视频要求：时长10秒~5分钟以内；宽高比为1:1或3:4或16:9，上传后展示在商品轮播图首位</span>
                                <span>铺货时，仅支持店铺上传成功的商品轮播视频，若店铺未上传商品轮播视频，则不会发布视频信息</span>
                            </p>
                        </div>
                    </el-form-item>
                </div>
            </section>
            <section>
                <div class="title">
                    <span>商品规格与库存</span>
                </div>
                <div class="conf">
                    <template>
                        <template v-if="categoryId">
                            <el-form-item v-if="specTypes.length" label="规格类型:" prop="sizeType">
                                <el-radio-group v-model="value.sizeType" class="radio-wrap">
                                    <el-radio :label="item.id" v-for="item in specTypes" :key="item.id">{{item.name}}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="商品规格:" prop="skuAttrs">
                                <template>
                                    <RuleSortBtn :specifications.sync="propSpecifications" />
                                    <SpecsValuesSort :specifications.sync="propSpecifications" />
                                    <PddSpecification 
                                        ref="pddSpecification"
                                        :sizeType="value.sizeType"
                                        :imgLimits="isCheckSkuImg ? specImgLimits : {limitSuffix: '.png,.jpg,.jpeg'}"
                                        :canNoteItems="canNoteItems"
                                        :customSpecNum="customSpecNum"
                                        :carouselGallery="value.carouselGallery"
                                        v-model="propSpecifications"
                                        :specOptions="specOptions"
                                        :sizeTypeNames="sizeTypeNames"
                                        :changeToBase="changeToBase"
                                        :updateSpecIds="updateSpecIds"
                                        @change="specificationChange"
                                        :validateSkuRowImage="(v) => validateSkuImages(v)"
                                        @fieldChanged="specificationsFieldChanged"
                                    />
                                </template>
                            </el-form-item>
                            <el-form-item label="价格库存:" prop="skuAttrsDetail" id="priceStock">
                                <FormItemSkuList
                                    ref="formItemSkuListRef"
                                    v-model="skuList"
                                    :baseItemId="baseItemId"
                                    :specifications="propSpecifications"
                                    :tableCols="skuTableCols"
                                    :imgOnlyPreview="skuImgOnlyPreview"
                                    :isPdd="isPdd"
                                    :showBindSkuOuterId="openSource !== 'shopGoods'"
                                    skuOuterIdKey="outSkuSn"
                                    :validateSkuRowPrice="validateSkuRowPrice"
                                    :imgLimits="isCheckSkuImg ? specImgLimits : {limitSuffix: '.png,.jpg,.jpeg'}"
                                    :value="value"
                                    :config="pddConfig"
                                    @fieldChanged="skuListChange"
                                >
                                </FormItemSkuList>
                                <template v-if="specificationsValidResult !== true">
                                    <div class="el-form-item__error">{{specificationsValidResult}}</div>
                                </template>
                            </el-form-item>
                        </template>
                        <template v-else>
                            <el-form-item label="商品规格:" prop="skuAttrs">
                                <span class="no-suport ft-12">暂不支持的类目或当前类目无销售属性</span>
                            </el-form-item>
                        </template>
                    </template>
                     <el-form-item 
                        label="商品参考价:" 
                        prop="marketPrice"
                        :rules="[
                            {required: true, message: '请输入商品市场价'},
                            {validator: this.validatePrice}
                        ]"
                        >
                         <el-input
                            type="text"
                            placeholder=""
                            v-model="value.marketPrice"
                            width="200px"
                            >
                        </el-input><span class="text">元</span>
                    </el-form-item>
                    <template v-if="categoryId">
                         <el-form-item 
                            label="满件折扣:" 
                            prop="twoPiecesDiscount"
                            :rules="twoPiecesDiscountRules"
                            >
                            <span class="text">满2件</span>
                            <el-input-number
                                v-model="value.twoPiecesDiscount"
                                style="width: 150px"
                                :precision="1"
                                :controls="false"
                                :max="twoPiecesDiscountRule.maxTwoPiecesDiscount / 10"
                                :min="twoPiecesDiscountRule.minTwoPiecesDiscount / 10"
                            ></el-input-number>
                            <span class="text">折</span>
                            <span class="note">注: 商品满2件折扣与店铺满2件折扣不会叠加, 最低{{ twoPiecesDiscountRule.minTwoPiecesDiscount / 10 }}折, 最高{{ twoPiecesDiscountRule.maxTwoPiecesDiscount/10 }}折。</span>
                        </el-form-item>
                    </template>
                    <el-form-item label="商品编码:" prop="goodsSn">
                         <el-input
                            type="text"
                            placeholder=""
                            v-model="value.goodsSn"
                            width="200px"
                            >
                        </el-input>
                    </el-form-item>
                </div>
            </section>
            <section>
                <div class="title">
                    <span>服务与承诺</span>
                </div>
                <div class="conf">
                    <el-form-item label="商品类型:" prop="goodsType">
                        <el-radio-group v-model="value.goodsType" @change="handleGoodsTypeChanged">
                            <el-radio v-for="item in PROD_TYPE" :label="item.value" :value="item.value" :key="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="货源地:" prop="countryId" v-if="value.goodsType === 2 || value.goodsType === 3">
                        <el-select 
                            v-model="value.countryId"
                            clearable
                            filterable
                            width="200px"
                            :loading="countryLoading"
                            @visible-change="getPddCountryList"
                        >
                            <el-option
                                v-for="(item, idx) in ADDROPTIONS"
                                :key="idx"
                                :label="item.countryName"
                                :value="item.countryId"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否二手:" prop="secondHand">
                         <el-radio-group v-model="value.secondHand">
                            <el-radio v-for="item in SECOND_TYPE" :label="item.value" :value="item.value" :key="item.value">{{item.label}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="是否预售:" prop="isPreSale">
                         <el-radio-group v-model="value.isPreSale" @change="(v) => isPreSaleChange(v, value)">
                            <el-radio v-for="item in PRESELL_TYPE" :label="item.value" :value="item.value" :key="item.value">
                                <el-badge v-if="item.new" value="new" class="mgr20 badge">
                                    <span>{{item.label}}</span>
                                </el-badge>
                                <span v-else>
                                    {{item.label}}
                                </span>
                                <el-tooltip
                                    v-if="item.tip"
                                    effect="dark"
                                    :content="item.tip"
                                    placement="top">
                                    <i class="el-icon-warning"></i>
                                </el-tooltip>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="value.isPreSale === 1" key="pre-sale-time" label="预售时间:" prop="preSaleTime">
                        <el-input-number
                            v-model="value.preSaleTime"
                            controls-position="right"
                            :min="3"
                            :max="29"
                            width="100px"
                            style="text-align: left"
                            @blur="preSaleTimeChange"
                            @change="preSaleTimeChange"
                        ></el-input-number>
                        <span style="margin-left: 5px; font-size: 12px">天结束预售</span>
                        <span class="mgl12 ftsz12">
                            <span class="text-999">（若设置了部分sku预售时间，则款预售时间不生效）</span>
                            <a @click="toPriceStock" class="text-blue text-pointer">按sku设置预售时间</a>
                            <el-tooltip
                                effect="dark"
                                placement="top"
                            >
                                <div slot="content">规格(sku)维度预售，可设置规格在指定时间发货<br />注：若只需部分sku预售，请勿设置所有sku预售<br />时间，否则将会统一为最长预售时间。</div>
                                <i class="el-icon-warning"></i>
                            </el-tooltip>
                        </span>
                    </el-form-item>
                    <el-form-item v-if="value.isPreSale !== 2" key="normal-shipment-limit" label="承诺发货时间:" prop="shipmentLimitSecond">
                        <el-radio-group v-model="value.shipmentLimitSecond">
                            <!-- <el-radio
                                v-for="item in DELAY_TIME"
                                :label="item.value"
                                :value="item.value"
                                :key="item.value"
                            >{{item.label}}</el-radio> -->
                            <el-radio
                                :label="0"
                                :value="0"
                                :disabled="goodsServiceRuleMap && goodsServiceRuleMap['deliveryOneDayRule'] === 0" 
                            >当日发货</el-radio>
                            <template v-if="goodsServiceRuleMap && goodsServiceRuleMap.shipmentLimitSecondList && goodsServiceRuleMap.shipmentLimitSecondList.length > 0">
                                <el-radio
                                    v-for="item in goodsServiceRuleMap.shipmentLimitSecondList"
                                    :value="item"
                                    :key="item"
                                    :label="item"
                                >{{item | formatTime}}小时</el-radio>
                            </template>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-else key="period-shipment-limit" label="支付成功后:" prop="shipmentLimitSecond">
                        <el-select v-model="value.shipmentLimitSecond">
                            <el-option
                                v-for="(op) in PERIOD_PRESALE_OPTIONS"
                                :key="op.value"
                                :value="op.value"
                                :label="op.label"></el-option>
                        </el-select>
                        内发货
                    </el-form-item>
                    <el-form-item label="拼单要求:" prop="groupRequiredCustomerNum">
                         <span class="text" style="margin-right: 10px">拼单人数:</span>
                         <el-input
                            type="text"
                            v-model="value.groupRequiredCustomerNum"
                            width="100px"
                            disabled
                         ></el-input>
                    </el-form-item>
                    <template v-if="categoryId">
                        <el-form-item label="服务:">
                            <div v-if="goodsServiceRuleMap['privacyDeliveryRule'] === 1">
                                <el-checkbox
                                    v-model="value.promise.privacyDelivery"
                                    :false-label="0"
                                    :true-label="1"
                                >保密发货</el-checkbox>
                            </div>
                            <span v-else class="text">无</span>
                        </el-form-item>
                        <el-form-item v-if="goodsServiceRuleMap !== null" label="承诺:" prop="promise">
                            <div v-if="goodsServiceRuleMap['refundableRule'] !== 0">
                                <el-checkbox
                                    v-model="value.promise.isRefundable"
                                    :false-label="0"
                                    :true-label="1"
                                >7天无理由退换货
                                <span
                                    v-if="goodsServiceRuleMap['refundableRule'] === 2"
                                    class="no-suport" style="margin-left: 10px">
                                    必须支持【七天无理由退换货】服务</span>
                                </el-checkbox>
                            </div>
                            <div v-if="goodsServiceRuleMap['foltRule'] !== 0">
                                <el-checkbox
                                    v-model="value.promise.isFolt"
                                    :false-label="0"
                                    :true-label="1"
                                >假一赔十
                                <span
                                    v-if="goodsServiceRuleMap['foltRule'] === 2"
                                    class="no-suport" style="margin-left: 10px">
                                    必须支持【假一赔十】服务</span>
                                </el-checkbox>
                                
                            </div>
                            <div v-if="goodsServiceRuleMap['badClaimRule'] !== 0">
                                <el-checkbox
                                    v-model="value.promise.badFruitClaim"
                                    :false-label="0"
                                    :true-label="1"
                                    :disabled="disableBadFruitClaim"
                                >坏了包赔</el-checkbox>
                            </div>
                            <div v-if="goodsServiceRuleMap['lackOfWeightClaimRule'] !== 0">
                                <el-checkbox
                                    v-model="value.promise.lackOfWeightClaim"
                                    :false-label="0"
                                    :true-label="1"
                                >缺重包退
                                <span
                                    v-if="goodsServiceRuleMap['lackOfWeightClaimRule'] === 2"
                                    class="no-suport" style="margin-left: 10px">
                                    必须支持【缺重包退】服务</span>
                                </el-checkbox>
                            </div>
                            <div v-if="goodsServiceRuleMap['quanGuoLianBaoRule'] !== 0">
                                <el-checkbox
                                    v-model="value.promise.quanGuoLianBao"
                                    :false-label="0"
                                    :true-label="1"
                                >全国联保</el-checkbox>
                            </div>
                            <div v-if="goodsServiceRuleMap['zhiHuanBuXiuRule'] !== 0">
                                <el-checkbox
                                    v-model="value.promise.zhiHuanBuXiu"
                                    :false-label="0"
                                    :true-label="365"
                                >只换不修</el-checkbox>
                            </div>
                            <div v-if="goodsServiceRuleMap['canSelectDeliveryType'] === true">
                                <el-radio-group v-model="value.promise.deliveryType" >
                                    <el-radio :label="0">无物流发货</el-radio>
                                    <el-radio :label="1">有物流发货</el-radio>
                                </el-radio-group>
                            </div>
                        </el-form-item>
                    </template>
                </div>
            </section>
              <!-- 运费模板 -->
              <section>
                <div class="title ft-12">
                  <span>运费模板</span>
                </div>
                <div class="conf">
                  <el-form-item label="运费设置：">
                    <el-row v-if="shopList.length && shipsValue">
                      <el-col v-for="shop in shopList" :key="shop.id" :span="12" class="set-ship">
                        <el-image
                          :src="shop.icon"
                          style="width: 26px; height: 26px;  border-radius: 50%"
                          ></el-image>
                        <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                            <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
                        </el-tooltip>
                          <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
                          <el-select 
                            v-model="shipsValue[shop.id]" 
                            placeholder="请选择运费模板"
                            clearable
                            :value-key="String(shop.id)"
                            @visible-change="changeSelect(shop.id, shop.userId)"
                            >
                            <el-option
                              v-for="ship in shipsTemplate[shop.id]"
                              :key="ship.id"
                              :label="ship.name"
                              :value="ship.id"
                              >
                            </el-option>
                          </el-select>
                      </el-col>
                    </el-row>
                    <span v-else class="no-shops">暂无平台店铺</span>
                  </el-form-item>
                </div>
              </section>
              <!-- 上架设置 -->
              <section>
                <div class="title ft-12">
                  <span>上架设置</span>
                </div>
                <div class="conf">
                  <el-form-item 
                    label="上架设置:" 
                    :rules="[{required: true, message: '请输入上架设置', trigger: 'blur'}]">
                      <el-radio-group v-model="isOnshelf">
                          <el-radio :label="1">立即上架</el-radio>
                          <el-radio :label="2">放入草稿箱</el-radio>
                      </el-radio-group>
                  </el-form-item>
                </div>
              </section>
            
        </el-form>
        <ShopDialog :data="shopList" ref="ShopDialogRef"></ShopDialog>
    </div>
</template>
<script>
import '@/assets/css/prod.scss';
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'
import ImgUpload from '@/components/Uploads/ImgUpload.vue';
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue'
import { getGoodsBaseInfo } from '@/servers/prod/center'
import { getPddSpecId, getPddCategoryProperties,getPddBrandRequireRule, getPddSpecList, getGroupSpecNames, getPddCountryList, pddDataMap, uploadFile, uploadCarouselVideo, editCarouselVideo } from '@/servers/prod/center/pdd.js'

import CategoryInput from '../PlatformCategoryInput/index.vue';
import BrandIdBlock from './components/BrandIdBlock.vue';
import ShopDialog from './components/ShopDialog.vue';

import RULES, {validateSkuPrice} from './rules.js';
import { isEqual, get, cloneDeep } from 'lodash';
import {specification_mixin} from '../FormItemSpecification'
import CategoryAttr from './components/CategoryAttr.vue';
import UseCategoryTemplate from '../UseCategoryTemplate.vue'

import {SIZE_TYPE, PROD_TYPE, SECOND_TYPE, PRESELL_TYPE, DELAY_TIME, PERIOD_PRESALE_OPTIONS} from './config';

import { transToBase64} from './utils';
import { getBytesCount } from "@utils/data"

import genkey from '@/utils/genkey.js'
import PddSpecification from './components/FormItemSpecification.vue';
import {getDistributionConfig, getPddTemplateList} from '@servers/prod/conf/index.js'
import {mapGetters} from 'vuex';
import dayjs from 'dayjs';
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';
import VideoUpload from '@/components/Uploads/videoUpload'
import VideoState from './components/VideoState.vue';

// const sizeTypeNames = ['尺码', '童鞋尺码', '参考分类', '鞋码']
const defaultPromiseData = {
    privacyDelivery: null,
    isRefundable: null,
    isFolt: null,
    badFruitClaim: null,
    lackOfWeightClaim: null,
    quanGuoLianBao: null,
    deliveryType: null,
    zhiHuanBuXiu: null
}

export default {
    mixins: [specification_mixin, validateMixin, shopListMixin],
    provide(){
        return {
            platform: "pdd",
            openSource:this.openSource
        }
    },
    inject: {
        isGroupPuhuo: {
            form: 'isGroupPuhuo',
            default: false
        },
    },
    components: {
        MutiImgUpload,
        BatchEditImages,
        ImgUpload,
        GroupImagesList,
        CategoryInput,
        CategoryAttr,
        UseCategoryTemplate,
        PddSpecification,
        BrandIdBlock,
        ShopDialog,
        VideoUpload,
        VideoState
    },
    props: {
        formData: {
            type: Object,
            default() {
                return {};
            }
        },
        shopsList: {
            type: Array,
            default: ()=> {
                return []
            }
        },
        changeToBase: Function,
        baseItemId: [Number, String],
        isDistributor: Boolean,
        rowData: {
            type: Object,
            default: () => ({})
        },
        openSource:{
            type:String,
            default:''
        },
    },
    data() {
        return {
            platform: 'pdd',
            formKey: 'value',
            needValiSymbol: true, // 校验规格名规格值非法字符
            initAttrData: [],
            showGroupImages: true,
            mixinsFormKey: 'value',  // mixins FormItemSpecification/index.js 中用到
            SIZE_TYPE: SIZE_TYPE,
            PROD_TYPE: PROD_TYPE,
            SECOND_TYPE: SECOND_TYPE,
            PRESELL_TYPE: PRESELL_TYPE,
            DELAY_TIME: DELAY_TIME,
            PERIOD_PRESALE_OPTIONS,
            ADDROPTIONS: [],
            isPdd: true,
            skuImgOnlyPreview: false,
            specification_needImg: false, // 规格需要校验图片
            // ADDROPTIONS: [{countryId: 1, countryName: "安道尔"}, {countryId: 2, countryName: "阿联酋"}],
            countryLoading: false, // 货源地国家下拉框loading
            canNoteItems: [], // 可编辑备注的商品属性
            customSpecNum: 0, // 可以自定义规格数量
            specItemPropValues: [], // 类目属性带出来的规格值
            propSpecifications: [], // 类目属性带出来的规格信息{name: , nameKey, values: }
            specOptions: [],
            sizeTypeNames: [],
            oriSpecs: [],
            categoryId: '',
            detailCategoryId: '',
            detailCategoryIdChange: false,
            value: {
                categoryIds: [],  // 商品分类
                goodsName: '', // 商品标题
                goodsDesc: '',// 商品描述
                carouselGallery: [], // 商品轮播图
                detailGallery: [], // 商品详情图
                packageLabelGallery: [], // 包装标签图
                imageUrl: '', // 商品活动素材图 *
                imageUrl1: {content: ''}, // 商品白底图
                imageUrl3: {content: ''}, // 商品长图
                itemPropValues: [], // 类目属性 *
                sizeType: 1, // 尺码类型
                marketPrice: '', // 市场价
                goodsSn: '', // 商品编码
                goodsType: '1', // 商品类型
                countryId: '', // 货源地 受goodsType影响
                secondHand: 1, // 是否二手
                isPreSale: 1, // 是否预售
                preSaleTime: '', // 预售时间
                shipmentLimitSecond: '', // 承诺发货时间 受goodsType影响
                groupRequiredCustomerNum: '2', // 拼单人数 成团人数
                promise: cloneDeep(defaultPromiseData), // 承诺
                // isRefundable: 1, // 是否七天无理由
                // isFolt: 1, // 是否假一赔十
                skuList: [],
                specifications: [],
                twoPiecesDiscount: '', // 满件折扣
                primitiveTwoPiecesDiscount: '', // 满件折扣的初始值
                shopBrandConf: [],   // 品牌
                // carouselVideoInfo: [],
                carouselVideoId: null,
                carouselVideoVo: null,
            },
            skuTableCols: [],
            specImgLimits: {
                aspectRatio: 1,
                aspectRatioText: '1:1',
                limitWidth: [480, 0],
                limitSize: 5 * 1024 * 1024,
                limitSuffix: '.png,.jpg,.jpeg'
            },
            twoPiecesDiscountRule: '',// 满件折扣规则
            twoPiecesDiscountRules: [],  // 满件折扣表单验证是否必填
            shipsTemplate: null, // 运费模板列表
            shipsValue: null, // 运费模板值
            templateConfigMap: null, // 初始值
            originalTemplateConfig: null, // 原始运费模板配置（用于保存时恢复未显示店铺的数据）
            originalShopBrandConf: null, // 原始品牌配置（用于保存时恢复未显示店铺的数据）
            isOnshelf: 1,
            brandShopList: [], // 品牌店铺列表
            disableBadFruitClaim: false,
            originGoodsServiceRuleMap: {},
            goodsServiceRuleMap: {}, // 服务集合
            showPddSpec: true,
            pddConfig: {},
            videoStateDialog: { visible: false, data: null },
            autoCropImageConfigList:[],
            imgErrorInfoMsg:[],
            detailHasCategory: [],
            packageLabelGalleryError: '', // 包装标签图验证错误信息
        }
    },
    computed: {
        ...mapGetters(['shops_getCategoryPropShopId', 'userInfo']),
        shopList() {
            let list = this.getShopList('pdd');
            if(this.openSource === 'shopGoods'){
                list = list.filter(item => item.id == this.formData.shopId)
            }
            return list;
        },
        titleLength() {
            const goodsName = this.value.goodsName || '';
            return getBytesCount(goodsName);
        },
        specTypes() {
            const sizeItem = this.canNoteItems.find(s => this.sizeTypeNames.includes(s.name));
            if(!sizeItem?.values?.length) return [];
            let arr = sizeItem.values.reduce((acc, it) => {
                if (it.group) {
                    const idx = acc.findIndex(a => a.id === it.group.id);
                    if (idx === -1) {
                        acc.push(it.group);
                    }
                }
                return acc;
            }, []);
            const idx = arr.findIndex(a => a.id === this.value.sizeType);
            if (idx === -1 && arr[0]) {
                this.value.sizeType = arr[0].id;
            }
            return arr;
        },
        minMarketPrice() {
            let max = this.skuList.reduce((acc, row) => {
                if (acc < row.singlePrice) {
                    acc = row.singlePrice;
                }
                return acc;
            }, 0);
            return max + 1;
        },
        // 满件折扣规则
        newTwoPiecesDiscountRule() {
            return this.twoPiecesDiscountRule === 0 ? 0 : this.twoPiecesDiscountRule
        },
        rules () {
            return RULES(this);
        },
        isCheckDesc(){
            return this.isCheckImg('desc')
        },
        isCheckSkuImg(){
            return this.isCheckImg('skuImg')
        },
        isCheckCarouselGalleryImg(){
            return this.isCheckImg('carouselGalleryImg')
        },
    },
    filters: {
        formatTime(seconds = 0) {
            return seconds / 60 / 60;
        }
    },
    watch: {
        formData: {
            async handler(form) {
                const v = cloneDeep(form)
                await this.getConf()

                // 保存原始 templateConfig，用于保存时恢复未显示店铺的数据
                if (v.templateConfig && v.templateConfig.length) {
                    this.originalTemplateConfig = cloneDeep(v.templateConfig);
                }
                // 保存原始 shopBrandConf，用于保存时恢复未显示店铺的数据
                if (v.shopBrandConf && v.shopBrandConf.length) {
                    this.originalShopBrandConf = cloneDeep(v.shopBrandConf);
                }
                if (v.skuList) {
                    v.skuList = v.skuList.map(item => {
                        const valueKeys = item.skuSpecifications.filter(sp => sp.valueKey).map(sp => sp.valueKey)
                            return {
                                ...item,
                                valueKeys,
                                _skuid: valueKeys.join('-'),
                                skuPreSaleTimeDay: item.skuPreSaleTimeDay || '',
                            }
                        
                    })
                }
                if (v.specifications && v.specifications.length) {
                    this.specifications = JSON.parse(JSON.stringify(v.specifications));
                    this.oriSpecs = JSON.parse(JSON.stringify(v.specifications));
                }
                this.$set(this, 'initAttrData', v.itemPropValues || []);
                this.detailHasCategory = v.categoryIds

                if (!v.twoPiecesDiscount) {
                    // 满两件折扣取平台配置
                    v.twoPiecesDiscount = (this.pddConfig?.twoPiecesDiscount || 95) / 10;
                }
                // 上架设置
                this.isOnshelf = v.isOnshelf || this.pddConfig?.shelfState || 1;
                if(!v?.promise?.isFolt){
                    v.promise = { ...v.promise, isFolt: this.pddConfig?.isFolt }
                }
                this.$set(this, 'value', { ...this.value, ...v });

                // 运费模板
                this.initTemplateConfig();
                this.detailCategoryId = v.categoryIds ? v.categoryIds[v.categoryIds.length - 1] : '';
                if (v.countryId) {
                    this.getPddCountryList();
                }
                this.$nextTick(() => {
                    this.validPage();
                })
            },
            immediate: true
        },
        shopList: {
            handler(v) {
                this.getAllShopBrand();
            }
        },
        propSpecifications: {
            // 监听规格信息生成规格详情列表
            handler(v) {
                this.watchSpec(v);
            },
            immediate: true,
            deep: true
        },
        minMarketPrice(v) {
            if (this.value.marketPrice < v) {
                this.value.marketPrice = v;
            } else {
                if (this.value.marketPrice / (v-1) >= 10) {
                    this.value.marketPrice = (v-1) * 5;
                }
            }
        },
        'value.categoryIds': {
            handler(val) {
                if(val && val.length) {
                    this.categoryId = val[val.length-1]
                    this.getPddSpecNameList()
                    this.handleBadFruitClaim();
                    this.getAllShopBrand();
                    if(this.brandShopList?.length && (this.detailCategoryId != this.categoryId || this.detailCategoryIdChange)) {
                        this.detailCategoryIdChange = true
                        this.$nextTick(() => {
                            this.$refs.brandIdBlock?.useBrandConfInit();
                        });
                    }
                }
            },
            immediate: true
        }
    },
    mounted() {
        // 初始化
        this.initMultiPrice();
        this.getTableCols()
        this.getGroupSpecNamesData()
    },
    unmounted() {
        this.detailCategoryIdChange = false
    },
    methods: {
        isCheckImg(type){
            console.log(type,!this.autoCropImageConfigList.includes(type), this.autoCropImageConfigList, '-----!this.autoCropImageConfigList.includes(type)-----')
            return !this.autoCropImageConfigList.includes(type);
        },
        // 包装标签图变化时验证
        packageLabelGalleryChange() {
            this.$nextTick(async () => {
                if (this.$refs.packageLabelGallery) {
                    const errorMsg = await this.$refs.packageLabelGallery.method_validImage();
                    this.packageLabelGalleryError = errorMsg || '';
                }
            });
        },
        getWidthAndHeights(refName) {
            return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
        },
        handleCategoryChanged() {
            // this.$nextTick(() => {
            //     this.$refs.brandIdBlock?.useBrandConf();
            // });
        },
        isPreSaleChange(v, form) {

            let minPeriod =  3 * 24 * 60 * 60; // 最小时段预售时间

            if (v === 2 && form.shipmentLimitSecond < minPeriod) {
                // 是时段预售且当前值小于3天，则设置为3天
                form.shipmentLimitSecond = minPeriod 
            } else if ([0,1].includes(v) && !DELAY_TIME.map(({value}) => value).includes(form.shipmentLimitSecond)) {
                // 是预售且值没在选项中，这设置为48小时
                form.shipmentLimitSecond = 48*60*60;
            }
            v === 1 && this.preSaleTimeChange();
            this.$nextTick(() => {
                const formRef = this.$refs.form;
                if (!formRef) return;
                formRef.clearValidate(['preSaleTime', 'shipmentLimitSecond']);
                formRef.validateField('shipmentLimitSecond');
            });
        },
        // 针对类目cat_id=8172，设置坏了包赔默认勾选且不可编辑
        handleBadFruitClaim() {
            this.disableBadFruitClaim = false
            if(this.value.categoryIds[0] == '8172') {
                this.value.promise.badFruitClaim = 1;
                this.disableBadFruitClaim = true
            }
        },
        preSaleTimeChange() {
            if (!this.value.categoryIds) {
                return;
            }
            this.skuList.forEach(item => {
                item.skuPreSaleTime = dayjs().add(this.value.preSaleTime, 'd').format('YYYY-MM-DD');
                item.skuPreSaleTimeDay = this.value.preSaleTime;
            })
        },
        // 获取规格名列表
        async getPddSpecNameList() {
            const specOptions = await getPddSpecList({
                leafCategoryId: this.categoryId
            });
            this.specOptions = specOptions
        },
        getPddCountryList() {
            // ADDROPTIONS
            if (!this.ADDROPTIONS.length) {
                this.countryLoading = true;
                getPddCountryList({}).then(list => {
                    if (list) {
                        this.ADDROPTIONS = list;
                        this.countryLoading = false;
                        const countryId = this.value.countryId;
                        this.value.countryId = 0;
                        this.$nextTick(() => {
                            this.value.countryId = countryId;
                        })
                    }
                })
            }
        },
        async uploadImgSuccess(url, type) {
            this.value.imageUrl = url;
            this.value[`imageUrl${type}`] = {
                content: url,
                fileId: '',
                materialType: type
            }
        },
        deleteImg(type) {
            this.value[`imageUrl${type}`] = {};
        },
        watchSpec(v) { // watch propSpecifications
            const that = this
            const originSkuList = cloneDeep(this.value.skuList)
            v = v.filter(item => item.name && item.checked)
            if (v.length < 1) { // 纯商品
                this.skuList = [{
                    ...JSON.parse(JSON.stringify(this.computedValueForm)),
                    ...originSkuList[0],
                    skuSpecifications: []
                }]
                return
            }
            // 检查是否有规格值 - 不生成skulist
            const hasNoValues = !v.some(item => item.name && item.values.length && item.values.some(i => i.checked))
            if (hasNoValues) {
                this.skuList = []
                return
            } 
            let _skuList = []
            const oldSkuList = cloneDeep(this.skuList)
            const allIsEdited = v.some(s => s.isEdited)
            function forEach(arr, index = 0, c_arr = []) {
                // 取到最后一层开始作业务逻辑
                if (arr.length === index) {
                    // 若有值为空或未勾选不做任何处理
                    if (c_arr.some(item => (!item.value || !item.checked))) return

                    const valueKeys = c_arr.filter(item => !!item.valueKey).map(item => item.valueKey)
                    const _skuid = valueKeys.join('-') // 生成skuid
                    const isEdited = c_arr.some(s => s.isEdited)
                    const _skuSpecifications = c_arr.map((item,index) => { //生成sku明细
                        const _sp = {
                            checked: that.getChecked(v[index].nameKey, item.valueKey, v),
                            name: v[index].name,
                            value: item.value,
                            nameKey: v[index].nameKey,
                            valueKey: item.valueKey,
                            propId: item.propId || item.parentSpecId,
                            propValueId: item.propValueId || item.specId
                        }
                        if (index === 0) {
                            _sp.imageUrl = that.getSkuImageUrl({
                                item,
                                valueKeys,
                                originSkuList,
                                skuList: oldSkuList,
                            });
                        }
                        return _sp
                    })
                    // 1. 现在当前skuList中找有无数据
                    // 2. 在self_form中找有无数据
                    // 3. 生成一个全新skuitem
                    
                    let skuItem = {
                        valueKeys,
                        _skuid,
                        skuSpecifications: _skuSpecifications,
                    };
                    // --- 1
                    const thisSkuObj = that.findSkuListItem(oldSkuList, valueKeys)
                    const thisSku = thisSkuObj.item
                    if (thisSku) {
                        let imgUrl = _skuSpecifications[0] && _skuSpecifications[0].imageUrl;
                        skuItem = {
                            ...thisSku,
                            ...skuItem,
                            // 规格图调整时，规格预览图是否变更: (注意：不变更时，拼多多规格图调整不影响预览图，除非预览图为空时，默认取规格图片)
                            skuImg: window.__spcificationImg_changed && that.pddConfig?.isUpdateSkuImg === 1 ? imgUrl : thisSku.skuImg || imgUrl, // 拼多多配置是否变更规格图片 0 不变更 1 变更
                            isGray: thisSku.isGray ? !(isEdited || allIsEdited) : thisSku.isGray
                        }
                        // console.log(that.pddConfig?.isUpdateSkuImg, imgUrl, skuItem, '---skuItem---')
                        _skuList.push(skuItem);
                        oldSkuList.splice(thisSkuObj.index, 1)
                        return
                    }
                    // --- 2
                    const selfSkuObj = that.findSkuListItem(originSkuList, valueKeys)
                    const selfSku = selfSkuObj.item
                    if (selfSku) {
                        skuItem = {
                            ...selfSku,
                            ...skuItem,
                        }
                        _skuList.push(skuItem)
                        originSkuList.splice(selfSkuObj.index, 1)
                        return
                    }
                    // --- 3
                    skuItem = {
                        ...skuItem,
                        ...JSON.parse(JSON.stringify(that.computedValueForm)),
                        isGray: !(isEdited || allIsEdited)
                    }
                    _skuList.push(skuItem)

                    return;
                }

                // 取出一层
                let currItem = arr[index]
                // 此层值循环
                currItem.values.forEach(c => {
                    // 每个值再递归取
                    forEach(arr, index + 1, c_arr.concat(c))
                })
            }
            forEach(v)
            this.skuList = _skuList
            window.__spcificationImg_changed = ''
            window.__spcificationCheckbox_changed = false;
        },
        getSkuImageUrl({ item, valueKeys, originSkuList, skuList }) {
            // 获取sku图片的逻辑统一处理
            if (!window.__spcificationImg_changed) {
                const thisSku = this.findSkuListItem(skuList, valueKeys).item;
                if (thisSku?.['skuSpecifications'][0]?.imageUrl) {
                    return thisSku.imageUrl || thisSku['skuSpecifications'][0].imageUrl;
                }
                const selfSku = this.findSkuListItem(originSkuList, valueKeys).item;
                if (selfSku) {
                    return selfSku.imageUrl || selfSku['skuSpecifications'][0]?.imageUrl || '';
                }
                return item.imageUrl || '';
            }

            if (window.__spcificationImg_changed) {
                if (valueKeys.indexOf(window.__spcificationImg_changed) > -1) {
                    return item.imageUrl || '';
                }
                const thisSku = this.findSkuListItem(skuList, valueKeys).item;
                if(thisSku) {
                    return thisSku['skuSpecifications'][0]?.imageUrl || item.imageUrl || '';
                }
            }

            return item.imageUrl || '';
        },
        findSkuListItem(list, valueKeys) {
            const otherData = {}
            let index = list.findIndex(sku => isEqual(sku.valueKeys, valueKeys))
            if(index === -1) {
                index = list.findIndex(sku => valueKeys.every(key => (sku.valueKeys || []).includes(key)) || sku.valueKeys?.every(key => (valueKeys || []).includes(key)))
                otherData.id = null
            }
            return {
                index, 
                item: index > -1 ? {...list[index], ...otherData} : null
            }
        },
        formatSepcValue(item, idx) {
            let val = {
                checked: item.checked,
                note: item.note || '',
                parentSpecId: item.propId || item.parentSpecId,
                specId: item.propValueId || item.specId,
                extendValues: item.extendValues,
                vvalue: item.value,
                valueKey: item.valueKey,
                refPid: item.refPid,
                groupId: item.groupId,
                vid: item.vid,
            }
            if (idx === 0) {
                val.imgUrl = item.imageUrl;
            }
            return val;
        },
        putSpecToItemPropValues (specifications){
            const refPids = this.canNoteItems.filter(Boolean).map(item => item.refPid);
            let itemPropValues = cloneDeep(this.value.itemPropValues);
            let attrVisibleRefPids = this.$refs.categoryAttr.attrs.map(item => {
                return item.visible !== false ? String(item.refPid) : false
            }).filter(Boolean);
            itemPropValues = itemPropValues.filter(item => (!refPids.includes(item.refPid) && attrVisibleRefPids.includes(item.refPid)));
            specifications.forEach((spec, idx) => {
                const isIn = this.canNoteItems.filter(Boolean).find(item => item.name === spec.name)
                if(isIn) {
                    (spec.values || []).forEach(item => {
                        itemPropValues.push(this.formatSepcValue(item, idx))
                    })
                }
            });
            return itemPropValues;
        },
        
        async uploadFunc(file) {
            const base64 = await transToBase64(file);
            let error = '';
            if (base64) {
                const imgUrl = await uploadFile({image: base64});
                if (imgUrl) {
                    return {url: imgUrl || ''};
                }
            } else {
                error = '文件转base64错误！'
                this.$message.error('文件转base64错误！')
            }
            return Promise.reject(error || '');
        },
        getPropSpecifications(saleProps, inputMaxSpecNum){
            // 1、inputMaxSpecNum = 0 && saleProps.length > 0, 只能有销售属性
            // 2、inputMaxSpecNum = 0 && saleProps.length = 0, 可以有自定义属性（非销售属性）最多2个
            // 3、inputMaxSpecNum > 0, 自定义属性（非销售属性）最多为inputMaxSpecNum个
            let customSpecNum = saleProps.length ? inputMaxSpecNum : inputMaxSpecNum || 2;
            this.customSpecNum = Number(customSpecNum) || 0

            const salePropList = cloneDeep(saleProps).sort((a, b) => b.required - a.required);
            const specifications = cloneDeep(this.specifications);

            // 获取未匹配的规格名
            const getUnmatchedNames = (specs, saleProps) =>
                specs.filter(s => !saleProps.some(sp => s.name === sp.name || s.name.includes(sp.name) || sp.name.includes(s.name))).map(s => s.name);

            let unmatchedNames = getUnmatchedNames(specifications, salePropList);
            const specs = []
            let unMatchedSalePropList = []
            // 查找规格索引
            const findSpecIndex = (specs, name) => specs.findIndex(item => item.name === name);

            // 模糊查找规格索引
            const fuzzyFindSpecIndex = (specs, name) =>
                specs.findIndex(item => item.name && name && (item.name.includes(name) || name.includes(item.name)));
            // 处理销售属性
            salePropList.forEach(saleProp => {
                // 根据name精确匹配
                let specIdx = findSpecIndex(specifications, saleProp.name);
                // 再模糊匹配
                if (specIdx === -1) {
                    specIdx = fuzzyFindSpecIndex(specifications, saleProp.name);
                }
                if(specIdx === -1 && unmatchedNames.length){
                    const unNIndex = unmatchedNames.findIndex(un => !this.specOptions.some(so => un === so.parentSpecName))
                    if(unNIndex > -1) {
                        specIdx = specifications.findIndex(item => item.name === unmatchedNames[unNIndex]);
                        unmatchedNames.splice(unNIndex, 1);
                    }
                }
                if(specIdx > -1) {
                    let spec = this.initSpec(saleProp);
                    const findSpecItem = specifications[specIdx];
                    spec.checked = !!findSpecItem.checked
                    spec.values = this.initSpecValues(findSpecItem, saleProp)
                    specifications.splice(specIdx, 1);
                    specs.push(spec);
                } else {
                    unMatchedSalePropList.push(saleProp)
                }
            })
            
            unMatchedSalePropList.filter(saleProp => saleProp.required).forEach(saleProp => {
                let spec = this.initSpec(saleProp);
                const findSpecItem = specifications[0] || {};
                spec.checked = !!findSpecItem.checked;
                spec.values = this.initSpecValues(findSpecItem, saleProp);
                specifications.splice(0, 1);
                specs.push(spec);
            });
            unMatchedSalePropList = unMatchedSalePropList.filter(saleProp => !saleProp.required)
            // 自定义属性（非销售属性）
            if(specifications.length && (customSpecNum || unMatchedSalePropList.length)) {
                specifications.forEach(s => {
                    if(customSpecNum) {
                        // 检查自定义规格名是否是通用属性列表中规格项
                        const spec = { ...s, isSale: false, parentSpecId: this.getParentSpecId(s.name) }
                        specs.push(spec);
                        customSpecNum--
                    } else if(unMatchedSalePropList.length) {
                        const saleProp = unMatchedSalePropList.shift()
                        let spec = this.initSpec(saleProp);
                        spec.checked = !!s.checked
                        spec.values = this.initSpecValues(s, saleProp)
                        specs.push(spec);
                    }
                })
            } 
            this.canNoteItems = salePropList;
            if (specs?.length) {
                let checkedSpec = specs.find(s => s.checked);
                if (!checkedSpec) {
                    checkedSpec = specs[0];
                    checkedSpec.checked = true;
                }
                checkedSpec.showImg = true;
            }
            return specs
        },
        initSpec(saleProp){
            let valueUnit = (saleProp.valueUnit || []).filter(Boolean)
            valueUnit = valueUnit.length && saleProp.inputMaxNum ? valueUnit : undefined;
            return {
                checked: false,
                required: saleProp.required,
                parentSpecId: saleProp.parentSpecId,
                name: saleProp.name,
                nameKey: saleProp.nameKey || saleProp.name,
                isSale: true,
                allowCreate: saleProp.inputMaxNum !== 0,
                canNote: saleProp.canNote,
                refPid: saleProp.refPid,
                valueUnit,
                values: []
            }
        },
        initSpecValues(specValueItem, saleProp) {
            let values = []
            let valueUnit = (saleProp.valueUnit || []).filter(Boolean)
            valueUnit = valueUnit.length && saleProp.inputMaxNum ? valueUnit : undefined;
            const options = saleProp.values || []
            if(specValueItem.values?.length) {
                values = specValueItem.values.map(propV => {
                    const option = options.find(o => o.value === propV.value || o.valueKey === propV.valueKey) || {}
                    const val = {
                        checked: propV.checked,
                        value: propV.vvalue || propV.value,
                        valueKey: propV.valueKey,
                        extendValues: propV.extendValues,
                        parentSpecId: saleProp.parentSpecId || '',
                        specId: option.specId || propV.specId || '',
                        propId: propV.propId || '',
                        propValueId: propV.propValueId || '',
                        groupId: option.group?.id || propV.groupId,
                        refPid: saleProp.refPid,
                        vid: option.vid || propV.vid,
                        note: propV.note || '',
                        imageUrl: propV.imageUrl
                    };
                    if (valueUnit && !val.extendValues?.specValue) {
                        val.extendValues = val.extendValues || {};
                        val.extendValues.specValue = { value: '', valueUnit: '' };
                        val.value = '';
                    }
                    if (propV.parentSpecId !== saleProp.parentSpecId) {
                        val.specId = '';
                    }
                    return val;
                })
            }
            return values;
        },
        getParentSpecId(name) {
            const specOptions = this.specOptions;
            if (!specOptions?.length) return;
            const idx = specOptions.findIndex(option => option.parentSpecName === name);
            if (idx !== -1) {
                const item = specOptions[idx];
                return item.parentSpecId
            }
            return '';
        },
        /**
         * 根据商品属性更新商品规格和规格类型
         */
        async updateSpec(saleProps, inputMaxSpecNum) {
            window.__spcificationImg_changed = ''
            const propSpecifications = this.getPropSpecifications(saleProps, inputMaxSpecNum)
          
            await Promise.all(
                propSpecifications.map(spec => this.updateSpecIds(spec))
            );
            this.propSpecifications = propSpecifications;
            this.$refs.formItemSpec?.fetch_getPddSpecList();
        },
        // 获取满件折扣：满两件折扣的规则
        updateDiscount(twoPiecesDiscountRule) {
            this.twoPiecesDiscountRule = twoPiecesDiscountRule;
            if (twoPiecesDiscountRule.ifMustTwoPiecesDiscount) {
                // 必填
                this.twoPiecesDiscountRules = [
                     {required: true, message: '请输入满件折扣'},
                ]
            } else {
                 // 非必填
                this.twoPiecesDiscountRules = [];
            }
            if (!this.value.primitiveTwoPiecesDiscount) {
                // this.value.twoPiecesDiscount = twoPiecesDiscountRule.recommendTwoPiecesDiscount / 10;
                // 配置优先
                this.value.twoPiecesDiscount = (this.pddConfig.twoPiecesDiscount || twoPiecesDiscountRule.recommendTwoPiecesDiscount) / 10;
            }
            // 服务与承诺-假一赔十
            if(!this.value?.promise?.isFolt){
                this.$set(this.value.promise, 'isFolt', this.pddConfig.isFolt)
            }
        },
        // 获取商品服务规则
        updateGoodsServiceRule(goodsServiceRule = null) {
            if (goodsServiceRule === null) return false;
            const { goodsServiceRuleMap = {} } = goodsServiceRule || {};
            const { goodsType } = this.value;
            this.goodsServiceRuleMap = goodsServiceRuleMap[goodsType] || {};
            this.setDefaultPromiseData();
            this.originGoodsServiceRuleMap = cloneDeep(goodsServiceRuleMap);
        },
        async getAllShopBrand() {
            if(!this.shopList?.length) return
            const res = await getPddBrandRequireRule({
                leafCategoryId: this.categoryId,
                shopIds: this.shopList.map(item => item.id).join() || ''
            })
            const brandShopList = []
            if (res && typeof res === 'object') {
                const shopKeys = Object.keys(res)
                this.shopList.map(shop => {
                    if(shopKeys.includes(shop.id + '')) {
                        brandShopList.push({
                            ...shop,
                            required: !!res[shop.id]
                        })
                    }
                })
            }
            this.brandShopList = brandShopList
        },

        setDefaultPromiseData() {
            const goodsServiceRuleMap = cloneDeep(this.goodsServiceRuleMap);
            // const defaultData = cloneDeep(defaultPromiseData);
            const promise = {};
            if (goodsServiceRuleMap['refundableRule'] === 2) {
                promise.isRefundable = 1;
            }
            if (goodsServiceRuleMap['foltRule'] === 2) {
                promise.isFolt = 1;
            }
            if (goodsServiceRuleMap['lackOfWeightClaimRule'] === 2) {
                promise.lackOfWeightClaim = 1;
            }
            Object.assign(this.value.promise, promise);
        },
        setSubmittPromiseData(data) {
            const goodsServiceRuleMap = cloneDeep(this.goodsServiceRuleMap);
            // const defaultData = cloneDeep(defaultPromiseData);
            const promise = {};
            // 7天无理由退换货
            if (goodsServiceRuleMap['refundableRule'] === 0) {
                promise.isRefundable = null;
            } else if (goodsServiceRuleMap['refundableRule'] === 2) {
                promise.isRefundable = 1;
            } else {
                promise.isRefundable = data.isRefundable || 0;
            }
            // 假一赔十
            if (goodsServiceRuleMap['foltRule'] === 0) {
                promise.isFolt = null;
            } else if (goodsServiceRuleMap['foltRule'] === 2) {
                promise.isFolt = 1;
            } else {
                promise.isFolt = data.isFolt || 0;
            }
            // 缺重包退
            if (goodsServiceRuleMap['lackOfWeightClaimRule'] === 0) {
                promise.lackOfWeightClaim = null;
            } else if (goodsServiceRuleMap['lackOfWeightClaimRule'] === 2) {
                promise.lackOfWeightClaim = 1;
            } else {
                promise.lackOfWeightClaim = data.lackOfWeightClaim || 0;
            }
            // 坏了包赔
            if (goodsServiceRuleMap['badClaimRule'] === 0) {
                promise.badFruitClaim = null;
            } else {
                promise.badFruitClaim = data.badFruitClaim || 0;
            }
            // 全国联保
            if (goodsServiceRuleMap['quanGuoLianBaoRule'] === 0) {
                promise.quanGuoLianBao = null;
            } else {
                promise.quanGuoLianBao = data.quanGuoLianBao || 0;
            }
            // 只换不修
            if (goodsServiceRuleMap['zhiHuanBuXiuRule'] === 0) {
                promise.zhiHuanBuXiu = null;
            } else {
                promise.zhiHuanBuXiu = data.zhiHuanBuXiu || 0;
            }
            // 保密发货
            if (goodsServiceRuleMap['privacyDeliveryRule'] === 0) {
                promise.privacyDelivery = null;
            } else {
                promise.privacyDelivery = data.privacyDelivery || 0;
            }
            // 物流方式
            if (goodsServiceRuleMap['canSelectDeliveryType'] === false) {
                promise.deliveryType = null;
            } else {
                promise.deliveryType = data.deliveryType || 0;
            }
            Object.assign(data, promise);
        },
        handleGoodsTypeChanged(goodsType) {
            const goodsServiceRuleMap = cloneDeep(this.originGoodsServiceRuleMap);
            this.goodsServiceRuleMap = goodsServiceRuleMap[goodsType] || {};
            // 切换商品类型后，需要清除之前的服务数据
            this.setDefaultPromiseData();
        },
        validatePrice(rule, value, callback) {
            value = String(value);
            const valueNum = Number(value);
            const idx = value.lastIndexOf('.');
            const mStr = value.slice(idx+1);
            if (isNaN(valueNum)) {
                callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
            } else if (valueNum < 0) {
                callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
            } else if (idx !== -1 &&  mStr.length > 2) {
                callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
            } else if (valueNum < this.minMarketPrice) {
                callback(new Error('不允许小于单买价的最大值+1'));
            } else {
                callback();
            }
        },
        validateSkuPrices() {
            let flags = [];
            const skuList = JSON.parse(JSON.stringify(this.skuList));
            for(let row of skuList) {
                flags.push(this.validateSkuRowPrice(row, 'singlePrice'));
                flags.push(this.validateSkuRowPrice(row, 'multiPrice'));
            }
            const flag = flags.some(fl => fl === false)
            return flag;
        },
        validateSkuImages(v) {
          const errorInfo = v.filter(Boolean)
          if(errorInfo && errorInfo.length){
            this.imgErrorInfoMsg = errorInfo
          }  else {
            this.imgErrorInfoMsg = []
          }
        },
        validateSkuRowPrice(row, field) {
            let msg = '';
            let valid = true;
            if(row.disabled || row.isGray) return valid
            if (field === 'singlePrice') {
                const calPrice = ((row.multiPrice || 0) + 1).toFixed(3)
                if (row.singlePrice === '') {
                    msg = '必填';
                } else if (row.singlePrice <= 0) {
                    msg = '最小0.01';
                } else if (row.singlePrice < Number(calPrice)) {
                    msg = '需大于拼单价+1'
                }
            } else if (field === 'multiPrice') {
                if (row.multiPrice === '') {
                    msg = '必填';
                } else if (row.multiPrice <= 0) {
                    msg = '最小0.01';
                }
                const calPrice = ((row.multiPrice || 0) + 1).toFixed(3)
                if (row.singlePrice <  Number(calPrice)) {
                    const errorMsg = '需大于拼单价+1'
                    if (row[`singlePriceError`] !== errorMsg) {
                        row[`singlePriceError`] = errorMsg
                    }
                    valid = false;
                } else {
                    if (row[`singlePriceError`] !== undefined) {
                        delete row[`singlePriceError`];
                    }
                    valid = true;
                }
            } else if(field === 'quantity') {
                if (row.quantity === '') {
                    msg = '必填';
                }
            }
            if (msg) {
                if (row[`${field}Error`] !== msg) {
                    row[`${field}Error`] = msg;
                }
                valid = false;
            } else {
                if (row[`${field}Error`] !== undefined) {
                    delete row[`${field}Error`];
                }
            }
            return valid;
        },
        async updateSpecIds(spec, specNames) {
            let { parentSpecId, name, values } = spec || {}
            if (!parentSpecId) {
                parentSpecId = this.getParentSpecId(name)
            }
            specNames = specNames || values.map(v => v.value).filter(Boolean)
            if(!parentSpecId || !specNames.length) return
            const specIdList = await getPddSpecId({ parentSpecId, specNames,leafCategoryId: this.categoryId })
            if(specIdList.length) {
                spec.values.forEach(v => {
                    const findItem = specIdList.find(item => (v.value || '').trim() === (item.specName || '').trim())
                    if(findItem) {
                        v.parentSpecId = findItem.parentSpecId;
                        v.specId = findItem.specId;
                        v.propId = findItem.parentSpecId;
                        v.propValueId = findItem.specId;
                    }
                })
            }
        },
        updateSkuListPropValueId() {
            this.skuList.forEach(sku => {
                sku.skuSpecifications.forEach(it => {
                    const findSpec = this.propSpecifications.find(s => s.name === it.name)
                    if (!findSpec) return
                    const findValue = findSpec.values.find(v => v.value === it.value)
                    if (!findValue) return
                    it.propValueId = findValue.propValueId;
                    it.propId = findValue.propId;
                })
            })
        },
        async valid_form() {
            return new Promise(async (resolve) => {
                if (!this.$refs.form) {
                    resolve(false);
                    return false;
                }
                const form = new Promise(resolve => {
                    this.$refs.form.validate(valid => {
                        resolve(valid)
                    })
                })
                const promises = [form];
                if (this.$refs.categoryAttr) {
                    promises.push(this.$refs.categoryAttr.validate())
                }
                if(this.$refs.brandIdBlock) {
                    promises.push(this.$refs.brandIdBlock?.method_validate());
                }
                Promise.all(promises).then(valids => {
                    const allIsValid = valids.every(item => {
                        return item === true;
                    });
                    resolve(allIsValid);
                }).then(() =>{
                    resolve(false)
                })
            });
        },
        async specificationChange(sps) {
          this.$nextTick(async () => {
                await this.valid_specifications()
                this.getErrorCount()
            })
        },
        specificationsFieldChanged() {
            this.$nextTick(async () => {
                await this.valid_specifications()
                this.getErrorCount()
            })
           
        },
        async skuListChange() {
            this.$nextTick(async () => {
                await this.valid_specifications()
                this.getErrorCount()
            })
        },
        async valid_specifications() {
            return new Promise(async (resolve, reject) => {
                if (this.$refs.pddSpecification) {
                    let validSpecId = this.$refs.pddSpecification.validate();
                    if (!validSpecId) {
                        resolve(false);
                        return;
                    }
                }
                if (this.validateSkuPrices()) {
                    this.specificationsValidResult = '请正确填写价格库存列表';
                    resolve(false);
                    return;
                }
                if (this.imgErrorInfoMsg.length) {
                    this.specificationsValidResult = '请正确上传图片内容';
                    resolve(false);
                    return;
                }
                const specificationsValid = await this.validateSpecifications(this.propSpecifications);
                this.specificationsValidResult = specificationsValid;
                if (specificationsValid !== true) {
                    resolve(false);
                    return;
                }
                resolve(true);
            });
        },
        formatPropSpecifications(propSpecifications) {
            let newSpecifications = cloneDeep(propSpecifications).map((item, index) => {
                item.values = item.values.map((v) => {
                    let val = {
                        ...v,
                        propId: v.parentSpecId || v.propId,
                        propValueId: v.specId || v.propValueId
                    }
                    if (!item.showImg) {
                        delete val.imageUrl;
                        delete val.imgUrlError;
                    }
                    if (this.sizeTypeNames.includes(item.name)) {
                        val.groupId = this.value.sizeType;
                    }
                    return val;
                })
                delete item.isSale
                delete item.allowCreate
                delete item.canNote
                delete item.showImg
                delete item.required
                return item
            })
            return newSpecifications;
        },
        async method_getFormData() {
            try {
                // 1. 表单验证
                const isValid = await this.validPage();
                if (!isValid) {
                    this.$message.error('请完善表单信息');
                    return false;
                }
                
                // 2. 预售状态检查
                const isPreSaleCanceled = await this.checkPreSaleStatus();
                if (isPreSaleCanceled) {
                    return false;
                }
                
                // 3. 数据处理和构建
                return this.buildFormData();
                
            } catch (error) {
                console.error('获取表单数据失败:', error);
                this.$message.error('请完善表单信息');
                return false;
            }
        },
        
        // 检查预售状态
        checkPreSaleStatus() {
            return new Promise((resolve) => {
                this.judgeAllSkuPreSale((isCancel) => {
                    resolve(isCancel || false);
                });
            });
        },
        
        // 构建表单数据
        buildFormData() {
            // 深拷贝原始数据
            const value = cloneDeep(this.value);
            
            // 更新SKU属性值ID
            this.updateSkuListPropValueId();
            
            // 获取规格数据
            const [specifications, skuList] = this.getSpecificationData(this.propSpecifications);
            const newSpecifications = this.formatPropSpecifications(specifications);
            
            // 获取分类名称
            const categoryNames = this.$refs.categoryInput.method_getCategoryNames();
            
            // 确保商品描述长度
            this.ensureGoodsDescLength(value);
            
            // 设置提交数据
            this.setSubmittPromiseData(value);
            
            // 构建最终数据
            return {
                ...value,
                itemPropValues: this.putSpecToItemPropValues(newSpecifications),
                goodsCategoryName: categoryNames[0] || '',
                lastCategoryName: categoryNames[categoryNames.length - 1] || '',
                lastCategory: value.categoryIds[value.categoryIds.length - 1],
                carouselGallery: (value.carouselGallery || []).filter(url => !!url), // 商品轮播图
                packageLabelGallery: (value.packageLabelGallery || []).filter(url => !!url), // 包装标签图
                specifications: newSpecifications,
                skuList,
                shopBrandConf: this.mergeHiddenShopData(cloneDeep(value.shopBrandConf), this.originalShopBrandConf, this.shopList),
                templateConfig: (() => {
                    let current = JSON.parse(this.handleTemplateConfig());
                    current = this.mergeHiddenShopData(current, this.originalTemplateConfig, this.shopList);
                    return JSON.stringify(current);
                })(),
                isOnshelf: this.isOnshelf,
                shopId: this.shops_getCategoryPropShopId('pdd')
            };
        },
        
        // 确保商品描述长度至少20个字符
        ensureGoodsDescLength(value) {
            let goodsDesc = value.goodsDesc || ''
            if (goodsDesc.length < 20) {
                const paddingLength = 20 - goodsDesc.length;
                goodsDesc += ' '.repeat(paddingLength);
                value.goodsDesc = goodsDesc;
            }
        },

        // 是否所有sku都设置了预售时间，若有全部设置，则弹窗提示（商品编辑弹窗不关闭）
        judgeAllSkuPreSale(callback) {
            if (this.value.isPreSale !== 1) {
                // 不是定时预售
                callback();
                return;
            }
            const skuList = cloneDeep(this.skuList);
            let allSkuPreSale = this.skuList.every(item => item.skuPreSaleTime);
            // 填过一个sku预售时间的就是sku预售，一个都没填就是款预售
            this.value.isSkuPreSale = this.skuList.some(item => item.skuPreSaleTime) ? 1 : 0;
            if (allSkuPreSale) {
                let maxDays = skuList.reduce((total, current) => {
                    let result = dayjs(current.skuPreSaleTime).diff(dayjs().startOf('day'), 'd') > total ? dayjs(current.skuPreSaleTime).diff(dayjs(), 'd') : total;
                    current.skuPreSaleTime = null;
                    return result;
                }, 0);
                return this.$confirm(`<div>款式编码为<span class="text-orange">${this.value.goodsSn}</span>的商品，在售规格全部设置为预售，已为您生成预售商品，预售时间统一为 ${dayjs().add(maxDays + 1, 'd').format('YYYY-MM-DD')} ，点击“确认”生效。<br />若您想仅部分规格设置预售，可点击“取消”后进行调整。<br />注：不要把所有规格都设置预售时间，只设置指定规格即可</div>`, '提示', {
                    dangerouslyUseHTMLString: true,
                }).then(() => {
                    this.value.isSkuPreSale = 0;
                    this.value.preSaleTime = maxDays + 1;
                    callback();
                }).catch(() => {
                    callback(true);
                });
            } else {
                callback();
            }
        },
        handleTemplateConfig() {
            const arr = [];
            Object.keys(this.shipsValue).forEach(key => {
                this.shipsTemplate[key].forEach(item => {
                    const channel = this.shopList.find(shop => shop.id == key)?.channel
                    if(item.id == this.shipsValue[key]){
                        arr.push({
                            shopId: key,
                            templateId: item.id,
                            templateName: item.name,
                            channel
                        })
                    }
                })
            })
            return JSON.stringify(arr);
        },
        // 处理拼多多详情 templateConfig
        initTemplateConfig() {
            const ships = {};
            this.shopList.forEach(shop => {
                ships[shop.id] = '';
            });
            const templateConfigMap = {};
            this.value.templateConfig = this.value.templateConfig ? this.value.templateConfig : [];
            this.value.templateConfig.forEach(item => {
                templateConfigMap[item.shopId] = {
                templateId: item.templateId,
                templateName: item.templateName,
                };
            });
            (this.pddConfig?.templateList || []).forEach(item => {
                if (!templateConfigMap[item.shopId]) {
                templateConfigMap[item.shopId] = {
                    templateId: item.templateId,
                    templateName: item.templateName,
                };
                }
            });
            this.templateConfigMap = templateConfigMap;
            Object.keys(templateConfigMap).forEach(key => {
                ships[key] = templateConfigMap[key].templateId;
            });
            this.shipsValue = ships;
            this.initShipsTemplate(templateConfigMap);
        },
        // 处理每个店铺下拉框
        initShipsTemplate(templateConfigMap) {
            const shipsTemplate = {};
            this.shopList.forEach(shop => {
                shipsTemplate[shop.id] = [];
            });
            Object.keys(templateConfigMap).forEach(key => {
                shipsTemplate[key] = [
                {
                    id: templateConfigMap[key].templateId || '',
                    name: templateConfigMap[key].templateName || '',
                },
                ];
            });
            this.shipsTemplate = shipsTemplate;
        },
        // 获取配置
        async getConf() {
            const res = await getDistributionConfig({shopType: 'PinShop'});
            this.autoCropImageConfigList = res.autoCropImageConfigList ? res.autoCropImageConfigList : [];
            this.pddConfig = res;
        },
        // 获取模板
        async getTemplateList(userId) {
            const list = await getPddTemplateList({
                offset: 0,
                limit: 100,
                searchUsed: false,
                userId: userId
            });
            if (list) {
                return list.map(ship => {
                    return {
                        name: ship.templateName,
                        id: ship.templateId.toString()
                    }
                });
            }
            return [];
        },
        async changeSelect(shopId, userId) {
            const list = await this.getTemplateList(userId);
            const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
            if (idx === -1) {
                this.shipsValue[shopId] = '';
            }
            this.$set(this.shipsTemplate, shopId, list);
        },
        
        // 初始化pdd拼单价
        async initMultiPrice() {
            if (!this.baseItemId) {
                return;
            }
            let res = await getGoodsBaseInfo(this.baseItemId, {isDistributor: true});
            let baseSkuList = get(res, 'skuList', []);
            this.skuList = this.skuList.map(item => {
                let multiPriceItem = baseSkuList.find(i => i.id === item.baseSkuId);
                let multiPrice = get(multiPriceItem, 'salesPrice', '');
                return {
                    ...item,
                    multiPrice: item.multiPrice || multiPrice,
                }
            })
        },
        toPriceStock() {
            if (!this.categoryId) {
                return this.$message.warning('请先选择平台类目');
            }
            let dom = document.getElementById('priceStock');
            dom.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        },
        useGroupImages(data, type) {
            const { mainImages = [], detailImages = [], speImages = [] } = data;
            let pic = [],
                description = [];
            if (type === 'add') {
                pic = [...this.value.carouselGallery].filter(Boolean);
                description = [...this.value.detailGallery];
            }
            if(mainImages.length) {
                this.value.carouselGallery = [...pic, ...mainImages].filter(Boolean).slice(0, 50);
            }
            if(detailImages.length) {
                this.value.detailGallery = [...description, ...detailImages].filter(Boolean).slice(0, 50);
            }
            const firstSpec = this.propSpecifications[0];
            if (firstSpec && firstSpec.values && speImages.length) {
                firstSpec.values.forEach(specValue => {
                    // 如果是新增模式且已有图片，则跳过
                    if (type === 'add' && specValue.imageUrl) {
                        return;
                    }
                    // 查找匹配的图片
                    const matchedImage = speImages.find(img => img.name === specValue.value);
                    if (matchedImage) {
                        specValue.imageUrl = matchedImage.imgUrl;
                    }
                });
                if(this.pddConfig?.isUpdateSkuImg === 1) {
                    this.skuList.forEach(sku => {
                        const matchedImage = speImages.find(img => img.name === sku.skuSpecifications[0]?.value);
                        if (matchedImage) {
                            sku.skuImg = matchedImage.imgUrl
                            sku.skuSpecifications[0].imageUrl = matchedImage.imgUrl
                        }
                    })
                }
            }
        },
        getGroupImagesList (list){
          this.showGroupImages = !!list?.length
        },
        editGroupImages(){
          this.changeToBase('openGroupImgs')
        },
        // 上传视频
        async handleVideo(value, type) {
            // type 0 删除 1 成功
            this.value.carouselVideoVo = type === 1 ? { ...value } : null;
            this.value.carouselVideoId = null;
            if(this.value.carouselVideoVo) {
                const videoId = await editCarouselVideo({
                    carouselVideoVo: this.value.carouselVideoVo,
                    baseItemId: this.baseItemId
                });
                this.value.carouselVideoId = videoId
            }
        },
        shopsUpdateVideo() {
            if(!this.value.carouselVideoVo) {
                this.$message.warning('请先添加视频后上传店铺！');
            } else {
                this.$refs.ShopDialogRef.method_open({
                    okFn: async (shopIds) => {
                        let params = {
                            baseItemIds: [this.baseItemId],
                            shopIds
                        }
                        let carouselVideoId = this.value.carouselVideoId || this.formData?.carouselVideoVo?.videoId || ''
                        // if(this.openSource === 'shopGoods') {
                            params.carouselVideoId = carouselVideoId
                        // }
                        let res = await uploadCarouselVideo(params);
                        if(res) {
                            this.$message.success('上传视频成功！');
                        }
                    }
                })
            }
        },
        clickTemPlateFill(row) {
            const platformCatProp = row.platformCatProp ? JSON.parse(row.platformCatProp) : []
            this.value.itemPropValues = platformCatProp
            this.initAttrData = platformCatProp
        },
        getTableCols() {
            const originForm = JSON.parse(localStorage.getItem('_origin_form'));
            const isDistribution = originForm?.isDistribution === 0;
            let openSource = this.openSource
            let isShowPreviewPrice = true;
            if(['taskCenter','previewPublish'].includes(openSource)){
                isShowPreviewPrice = false
            }
            let skuTableCols = [
                {
                    prop: 'multiPrice',
                    attrs: { label: '拼单价',width: '120px' },
                    input: { type: 'number', validator: validateSkuPrice },
                    previewPrice: isShowPreviewPrice,
                    previewPriceType: 'sales',
                },
                {
                    prop: 'singlePrice',
                    attrs: { label: '单买价',width: '120px' },
                    input: { type: 'number', validator: validateSkuPrice },
                    previewPrice: isShowPreviewPrice,
                    previewPriceType: 'market',
                },
                { prop: 'skuSupplyPrice', attrs: { label: '供货价', noRequired: true }, unvisible: isDistribution ? true : false },
                {
                    prop: 'quantity',
                    attrs: { label: '库存' },
                    input: { type: 'number' },
                    disabledFn: row => row.stockType === 1,
                },
                {
                    prop: 'weight',
                    attrs: { label: '重量', noRequired: true },
                    input: { type: 'number', attrs: { precision: 4 } },
                },
                { prop: 'outSkuPlatform', attrs: { label: 'sku编码', noRequired: true, width: 160, headerTooltip: '平台规格编码，对应平台sku外部商家编码，用于管理商品，并匹配ERP商品' }, input: { type: 'text' } },
                this.openSource !== 'shopGoods' ? { prop: 'outSkuSn', attrs: { label: '基础资料商家编码', width: 160, noRequired: this.isGroupPuhuo, headerTooltip: this.isGroupPuhuo ? '' : '必填，用于关联基础资料规格明细' }, input: { type: 'text', onlyTable: true } } : null,
            ];
            skuTableCols = skuTableCols.filter(Boolean)
            this.skuTableCols = isDistribution ? skuTableCols.filter(item => item && item.prop !== 'skuSupplyPrice') : skuTableCols;
        },
        async getGroupSpecNamesData() {
            let data = await getGroupSpecNames()
            this.sizeTypeNames = data || []
        }
    }
}
</script>

<style lang="scss" scope>
.radio-wrap > label{
    margin-right: 14px;
}
.note {
    color: red;
    font-size: 12px;
    padding-left: 15px;
}
.warning-tips {
    font-size: 11px;
    font-weight: bold;
    color: red;
    .warning-tips-icon {
        font-size: 15px;
        margin-bottom: 2px;
    }
}
.badge .el-badge__content.is-fixed {
    transform: translateY(-65%) translateX(100%) scale(0.8);
}

// 禁用状态下禁止所有表单元素交互
.is-disabled {
    pointer-events: none;
    opacity: 0.6;

    * {
        pointer-events: none;
    }
}
.upload-error-tips {
    color: #F56C6C;
    font-size: 12px;
    line-height: 20px;
    margin-top: 8px;
}
</style>
